export default __webpack_public_path__ + "static/media/fusion-006.c4b0e7c5.svg";